export interface JudgeSpan {
  id: string;
  judgeName: string;
  startMs: number;
  endMs: number;
}

/** Same trimmed judge name with overlapping bars. Display only. */
export function findJudgeConflicts(spans: JudgeSpan[]): Set<string> {
  const conflicting = new Set<string>();
  const groups = new Map<string, JudgeSpan[]>();

  spans.forEach((span) => {
    const name = span.judgeName.trim().toLowerCase();
    if (!name || span.endMs <= span.startMs) {
      return;
    }
    const group = groups.get(name) || [];
    group.push(span);
    groups.set(name, group);
  });

  groups.forEach((group) => {
    for (let i = 0; i < group.length; i++) {
      for (let j = i + 1; j < group.length; j++) {
        const a = group[i];
        const b = group[j];
        if (a.startMs < b.endMs && b.startMs < a.endMs) {
          conflicting.add(a.id);
          conflicting.add(b.id);
        }
      }
    }
  });

  return conflicting;
}
